module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woman-mobile_10d978.png";